import React from "react";
import { IconType } from "react-icons";

interface buttonProps {
  label: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  outline?: boolean;
  small?: boolean;
  custom?: boolean;
  icon?: IconType;
  iconFront?: IconType;
}

const ButtonComp: React.FC<buttonProps> = ({
  label,
  onClick,
  icon: Icon,
  disabled,
  outline,
  small,
  custom,
  iconFront: IconFront,
}) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`disabled:opacity-80
  disabled:cursor-not-allowed
  rounded-md
  hover-opacity-80
  transition
  w-full
  border-slate-700
  flex
  items-center
  justify-center
  gap-2
  ${outline ? "bg-white" : "bg-slate-700"}
  ${outline ? "text-slate-700" : "text-white"}
  ${small ? "text-sm font-light" : "text-md font-semibold"}
  ${small ? "py-1 px-2 border-[1px]" : "py-3 px-4 border-2"}
  ${custom ? "" : null}
  `}
    >
      {Icon && <Icon size={20} />}
      {label}
      {IconFront && <IconFront size={24} />}
    </button>
  );
};

export default ButtonComp;
